import EventActionProto from '../event-action-proto';
import SessionLoader from "core/gd/data/session-loader";

export default class SessionTaskMove extends EventActionProto {

    constructor(sessionEvent) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)
        this.method     = sessionEvent.method
        this.header     = {
            task        : sessionEvent.task,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
        this.fromSID    = sessionEvent.fromSID
    }

    process() {
        if (this.isDifferentCompany()) return false;

        // console.log("SessionTaskMove process", this);

        let sessionLoader = new SessionLoader();

        sessionLoader.process(gd.session.findMissing({
            statuses: [this.data.taskStatusId],
        }));

        sessionLoader.done(()=>{
            gd.modelBus.newUpdate('task', this.method, this.header.task.id, this.data, this.header);
        });
    }
};